import { NodeTree, useEditorReturnType } from '@candulabs/craft';

export enum InsertMode {
  /**
   * Into always looks to insert an item into an element. If it cannot, it will bail
   */
  INTO = 'INTO',
  /**
   * Into always looks to insert an item next to an element. Parent node must be a canvas or it will bail.
   */
  NEXT_TO = 'NEXT_TO',
  /**
   *  Auto tries to figure out what's the best way to paste given the element we want to paste into and the content we're pasting
   */
  AUTO = 'AUTO',
}

export type InsertNodeTreesAtIndex = (
  nodeTrees: NodeTree[],
  parentNodeId: string,
  insertAtIndex: number,
  editor: useEditorReturnType,
  insertCallback: (nodeTrees: NodeTree[], parentNodeId: string, insertAtIndex: number) => void,
) => void;
